import { styled } from '@mui/material';
import { DesignTokens } from '../../../specify';
import { AlignDirection } from '../../types';

export const TBCell = styled('td', {
    shouldForwardProp: (prop) => prop !== 'cellAlign',
})<{ cellAlign?: AlignDirection }>(({ cellAlign }) => ({
    boxSizing: 'border-box',
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 16,
    paddingBottom: 16,
    borderTopStyle: 'solid',
    borderTopWidth: 1,
    borderTopColor: 'rgba(0, 0, 0, 0.12)',
    backgroundColor: DesignTokens.color.textWhite,
    textAlign:
        cellAlign === 'right'
            ? 'right'
            : cellAlign === 'center'
            ? 'center'
            : 'left',
}));
